class Expandable {
    constructor(domElement) {
        this.domElement = domElement;
        this.headerDomElement = this.domElement.getElementsByClassName(
            'expandable-header')[0];
        this.bodyDomElement = this.domElement.getElementsByClassName(
            'expandable-body')[0];

        this.bindEvents();
    }

    bindEvents() {
        this.headerDomElement.addEventListener('click',
            this.onHeaderClick.bind(this));
    }

    onHeaderClick(e) {
        e.preventDefault();

        this.domElement.classList.toggle('expandable-expanded');
    }
}

export default Expandable;
